<template>
  <div class="component">
    <div class=" form-wrap">
      <div class="form-list py-3">
      <div class="row order-history-area">

      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>

  .component {
    //
    .order-history-area{
      .order-no-header {
        position: relative;
        .order-no {
          display: inline-block;
          background-color: #82ba1d;
          color: #fff;
          padding: 0 .5rem;
        }
        .order-status-wrap {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          padding-left: 20px;
          background-color: #fff;
          width: 80px;
          .order-status {
            //          @extend %badge;
            position: absolute;
            right: 0;
            height: 100%;
          }
        }
      }
      //
      .download-btn{
          white-space:normal !important;
          word-wrap:break-word;
          padding-left: 2rem;
          position: relative;
          width:75%;
          &:before{
            font-family: FontAwesome;
            content: '\f019';
            font-size:1.2rem;
            color: #fff;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) translateX(0);
            left: 5%;
          }
        }

      //
      .form-group{
        margin-bottom:0;
      }

    }
    .order-history-area {



    }
    .orderer-header{
      color:#82ba1d;
      border:1px solid #82ba1d;
    }

    .form-list{
      padding:1rem;
    }

    .form-group{
      //    border-bottom: 1px solid #ccc;
    }
    .form-hr{
      height:1px;
      hr{
        margin:0;
      }
    }

    .description-area{
      a{
        color: #ea5536;
        text-decoration: underline;
        font-size: 0.9rem;
      }
      p{
        font-size: 0.9rem;
      }

    }
  }

</style>



// WEBPACK FOOTER //
// PageContent.vue?96afcc18